import con from '../../../connection';

const path = '/islogin';

const islogin = (url: string) => () => ({
  get: (option?: { noError?: boolean, noNetworkError?: boolean }) => con.get(url + path, {}, option?.noError, option?.noNetworkError),
});

export default islogin;
